import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-empty-details-list-page',
  templateUrl: './empty-details-list-page.component.html',
  styleUrls: ['./empty-details-list-page.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class EmptyDetailsListPageComponent {}
